import { render } from "./InformationIcon.svg?vue&type=template&id=3061dc94"
const script = {}
script.render = render

export default script